import { Observable } from 'rxjs';
import { Token } from './token';

export abstract class IRefreshTokenService {
  abstract getTokenValue(): string;
  abstract refreshToken(): Observable<any>;
  abstract getAuthToken();
  abstract isRefreshTokenValid(): boolean;
  abstract isAuthTokenValid(): boolean;
  abstract storeToken(token: Token): void;
  abstract getDefaultLocation(): string;
  abstract deleteToken();
}
